
import expandableText from '@Shared/Common/Scripts/Components/_expandableText';
import carousel from '@Shared/Common/Scripts/Components/carouselBase';
export default {
  data: function data() {
    return {
      tipItemHeadingFormat: '',
      visibleItemsCount: 3
    };
  },
  components: {
    expandableText: expandableText,
    carousel: carousel
  },
  methods: {
    init: function init(config) {
      this.tipItemHeadingFormat = config.labels ? config.labels.tipItemHeadingFormat || '' : '';
    }
  }
};